export class ResourceType {
    title: string;
    color = 0;
    id = 0;
}
